import { render, staticRenderFns } from "./FooterScroll.vue?vue&type=template&id=85da459c&"
import script from "./FooterScroll.vue?vue&type=script&lang=js&"
export * from "./FooterScroll.vue?vue&type=script&lang=js&"
import style0 from "./FooterScroll.vue?vue&type=style&index=0&id=85da459c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports